import type { PageTour } from '../types';

export const projectsTour: PageTour = {
  id: 'projects',
  label: 'Projects Tour',
  steps: [
    {
      target: '[data-tour="projects-header"]',
      title: 'Projects Overview',
      content: 'This is your projects hub. View, manage, and track all projects assigned to you or your team.',
    },
    {
      target: '[data-tour="projects-create"]',
      title: 'Create a Project',
      content: 'Click here to create a new project. You can set timelines, assign team members, and define milestones.',
    },
    {
      target: '[data-tour="projects-filters"]',
      title: 'Filter & Search',
      content: 'Use filters to narrow down projects by status, client, or team. The search bar helps you find projects quickly.',
    },
    {
      target: '[data-tour="projects-view-toggle"]',
      title: 'View Toggle',
      content: 'Switch between grid and list views to see your projects the way you prefer.',
    },
    {
      target: '[data-tour="projects-list"]',
      title: 'Project Cards',
      content: 'Each card shows key project details — status, progress, team members, and deadlines at a glance.',
    },
  ],
};
